import axios from "axios";
import * as apiConstants from "../utils/api-constants";
export const axiosInstance = axios.create();

function getIp() {
    return new Promise((resolve, reject) => {
        axios.get(apiConstants.GET_IP_ADDRESS).then((response) => {
            sessionStorage.setItem("ipAddress", response.data.ip)
            resolve(response.data.ip);
        }).catch((error) => {
            sessionStorage.setItem("ipAddress", "127.0.0.1");
            resolve("127.0.0.1");
        });
    });
};

axiosInstance.interceptors.request.use(async (config) => {
    const tokenResponse = await getIp();
    config.headers['Ip-Address'] = sessionStorage.getItem("ipAddress") ? sessionStorage.getItem("ipAddress") : tokenResponse;
    return config;
}, (error) => {
    return Promise.reject(error);
});

// handle response error general case
axiosInstance.interceptors.response.use(response => response,
    error => {
        const originalRequest = error.config;
        // Error
        const { response: { status } } = error;

        if (status === 401) {
            // Unauthorized request: maybe access token has expired!
            return refreshAccessToken(originalRequest);
        } else {
            return Promise.reject(error);
        }
    }
);